import { render, staticRenderFns } from "./DynamicModal.vue?vue&type=template&id=f016f596&scoped=true"
import script from "./DynamicModal.vue?vue&type=script&lang=js"
export * from "./DynamicModal.vue?vue&type=script&lang=js"
import style0 from "./DynamicModal.vue?vue&type=style&index=0&id=f016f596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f016f596",
  null
  
)

export default component.exports